import { __rest } from "tslib";
import { Select, Tooltip } from 'antd';
import { apiHolder, apis, inWindow } from 'api';
import classnames from 'classnames';
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import debounce from 'lodash/debounce';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import TagCloseIcon from '@web-common/components/UI/Icons/svgs/TagCloseSvg';
import contactSelect from '@web-common/images/contact.png';
import { TeamAvatar } from '@web-im/common/imUserAvatar';
import { getColor, getContactItemKey, getSelectedItemBySelectOrg, splitSearchHit, verifyEmail, creatExternalContentItem, transContactSearch2ContactItem, transOrgSearch2OrgItem, transCustomerSearchData, isOrg, } from '@web-common/components/util/contact';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import Avatar from '../../Avatar';
import styles from './index.module.scss';
import { FetchLock } from '@web-common/utils/utils';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import IconCard from '@web-common/components/UI/IconCard';
import lodashGet from 'lodash/get';
import { getIn18Text } from 'api';
import { CustomerLabelByRole } from '@web-mail/components/ReadMail/component/CustomerLabel';
const systemApi = apiHolder.api.getSystemApi();
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const renderTagFunc = (emailNotDel, otherArgs) => (props) => {
    const { value, label, onClose } = props;
    let name = value;
    let email = value;
    let avatar;
    if (label.props && React.isValidElement(label) && label.props.item) {
        const item = label.props.item;
        name = item.name;
        email = item.email;
        avatar = item.avatar;
    }
    const valiteEmail = verifyEmail(String(email === null || email === void 0 ? void 0 : email.trim()));
    return (React.createElement("div", { "data-test-id": "contact_select_input_tag_item", className: classnames(styles.tagWrapper, {
            [styles.tagWrapperError]: !valiteEmail,
        }) },
        (otherArgs === null || otherArgs === void 0 ? void 0 : otherArgs.hideAvatar) ? null : (React.createElement("div", { className: styles.tagAvatar },
            React.createElement(Avatar, { item: {
                    contact: {
                        avatar,
                        contactName: name,
                        color: getColor(email),
                    },
                } }))),
        React.createElement(Tooltip, { title: email, placement: "bottom" },
            React.createElement("div", { className: classnames(styles.tagName, {
                    [styles.tagNameError]: !valiteEmail,
                    [styles.tagNameWidth]: otherArgs === null || otherArgs === void 0 ? void 0 : otherArgs.characterLimit,
                }) }, (otherArgs === null || otherArgs === void 0 ? void 0 : otherArgs.characterLimit) && (name === null || name === void 0 ? void 0 : name.length) > (otherArgs === null || otherArgs === void 0 ? void 0 : otherArgs.characterLimit) ? `${name.slice(0, otherArgs === null || otherArgs === void 0 ? void 0 : otherArgs.characterLimit)}...` : name)),
        emailNotDel !== email && (React.createElement("span", { onClick: onClose, "data-test-id": "contact_select_input_btn_tagClose", className: styles.tagClose },
            React.createElement(TagCloseIcon, { className: "dark-invert" })))));
};
const OptionItem = ({ item, searchValue = '', isOrg }) => {
    let teamInfo;
    const renderHighLight = (text) => {
        if (!searchValue) {
            return text;
        }
        const result = splitSearchHit(searchValue, text || '');
        if (!result) {
            return text;
        }
        return (React.createElement(React.Fragment, null,
            result.head,
            React.createElement("b", { className: styles.hitText }, result.target),
            result.tail));
    };
    const renderDepartment = (department) => department.map(de => de.join('/')).join('-');
    let subtitle;
    let title;
    let department = '';
    let renderAvatar = React.createElement(React.Fragment, null);
    let titleLabelRole;
    let isContact;
    if (!isOrg) {
        const { email, name, position, avatar, id, type, customerRole } = item;
        title = renderHighLight(name || email || '');
        subtitle = renderHighLight(email);
        titleLabelRole = customerRole;
        isContact = true;
        if (Array.isArray(position)) {
            department = renderDepartment(position);
        }
        renderAvatar = React.createElement(AvatarTag, { size: 20, contactId: id, user: { email, name, avatar } });
    }
    else {
        const { id, orgName, avatar, memberNum, type, customerRole } = item;
        title = renderHighLight(orgName);
        subtitle = memberNum !== undefined ? memberNum + getIn18Text('REN') : '';
        if (type === 2002 || type === 2003) {
            titleLabelRole = customerRole;
        }
        if (type === 2000) {
            const teamId = id.startsWith('team_') ? id.split('team_')[1] : id;
            teamInfo = { teamId, avatar };
            renderAvatar = React.createElement(TeamAvatar, { style: { width: 20, height: 20 }, teamId: teamInfo.teamId, teamInfo: teamInfo });
        }
        else if (type === 2001) {
            renderAvatar = React.createElement(TeamAvatar, { style: { width: 20, height: 20 }, teamId: '5117576620', teamInfo: { teamId: '5117576620' } });
        }
        else if (item.type === 2002) {
            renderAvatar = React.createElement(IconCard, { type: "crmClient" });
        }
        else if (item.type === 2003) {
            renderAvatar = React.createElement(IconCard, { type: "hintClient" });
        }
    }
    return (React.createElement("div", { className: styles.optionWrapper, "data-test-id": "contact_select_input_option_item" },
        React.createElement("div", { className: styles.optionAvatarWrap }, renderAvatar),
        React.createElement("span", null, title),
        React.createElement("span", { hidden: !subtitle },
            "\uFF08",
            subtitle,
            "\uFF09"),
        React.createElement("span", { className: styles.optionDepart, hidden: !department }, department),
        titleLabelRole && React.createElement(CustomerLabelByRole, { role: titleLabelRole, isContact: isContact, style: { marginLeft: 8 } })));
};
const OptionNoDataItem = ({ searchValue }) => (React.createElement("div", { className: styles.contactSelectNoData, "data-test-id": "contact_select_input_option_noData" },
    React.createElement("span", { className: styles.contactIcon }),
    React.createElement("span", { className: classnames(styles.contactValue, 'sirius-flex-ellipsis-text') },
        getIn18Text('WAIBULIANXIREN'),
        searchValue)));
const SelectInput = prop => {
    const { className, isIM = true, showSuffix, showClear, useSuffixIcon = true, onClickSuffix, changeHandle, dropdownClassName, includeSelf, firstPositionNotDelEmail, hideAvatar = false, unSelect = false, multiRow = false, characterLimit = 0, ceiling = 0, repeatToast = false, singleType = false, showNoData = true, noRelateEnterprise = false, useEdm = true, needTeam = true, needPersonalOrg = true, _account, recent100, field, source } = prop, props = __rest(prop, ["className", "isIM", "showSuffix", "showClear", "useSuffixIcon", "onClickSuffix", "changeHandle", "dropdownClassName", "includeSelf", "firstPositionNotDelEmail", "hideAvatar", "unSelect", "multiRow", "characterLimit", "ceiling", "repeatToast", "singleType", "showNoData", "noRelateEnterprise", "useEdm", "needTeam", "needPersonalOrg", "_account", "recent100", "field", "source"]);
    const [searchList, setSearchList] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [maxTagCount, setMaxTagCount] = useState('responsive');
    const [scrollFlag, setScrollFlag] = useState(0);
    const ref = useRef(null);
    const [selectValue, setSelectValue] = useState(new Map());
    const fetchLock = useMemo(() => new FetchLock(), []);
    const refRorInput = useRef(null);
    const defaultSelectList = useMemo(() => {
        var _a;
        return (_a = props.defaultSelectList) === null || _a === void 0 ? void 0 : _a.filter(item => {
            return item;
        });
    }, [props.defaultSelectList]);
    const handleChange = async (values) => {
        if (firstPositionNotDelEmail && (values === null || values === void 0 ? void 0 : values.length) === 0) {
            return;
        }
        if (Array.isArray(defaultSelectList) && defaultSelectList.length < values.length) {
            setScrollFlag(pre => pre + 1);
        }
        if (Array.isArray(values)) {
            const orgList = [];
            const contactItemList = [];
            values.forEach(({ label }) => {
                const props = label === null || label === void 0 ? void 0 : label.props;
                if (props) {
                    const { item, isOrg, searchValue, noData } = props;
                    if (noData) {
                        searchValue && contactItemList.push(creatExternalContentItem(searchValue));
                    }
                    else if (!isOrg) {
                        contactItemList.push(item);
                    }
                    else {
                        orgList.push(item);
                    }
                }
            });
            let oldMap = new Map();
            if (orgList.length) {
                const idList = [];
                const edmIdList = [];
                orgList.forEach(org => {
                    if (org === null || org === void 0 ? void 0 : org.children) {
                        org.children.forEach(item => {
                            const itemKey = getContactItemKey(item, false);
                            oldMap.set(itemKey, item);
                        });
                    }
                    else {
                        if (org.type === 2002 || org.type === 2003) {
                            edmIdList.push(org.id);
                        }
                        else {
                            idList.push(org.id);
                        }
                    }
                });
                if (idList.length) {
                    const res = await getSelectedItemBySelectOrg({
                        selectedMap: oldMap,
                        idList,
                        checked: true,
                    });
                    res.contactItem.forEach((item, itemKey) => {
                        oldMap.set(itemKey, item);
                    });
                }
                if (edmIdList.length) {
                    const res = await getSelectedItemBySelectOrg({
                        selectedMap: oldMap,
                        idList: edmIdList,
                        checked: true,
                        useEdm: true,
                    });
                    res.contactItem.forEach((item, itemKey) => {
                        oldMap.set(itemKey, item);
                    });
                }
            }
            contactItemList.forEach(item => {
                const key = getContactItemKey(item);
                const isSelected = oldMap.has(key);
                if (isSelected) {
                    oldMap.delete(key);
                }
                else {
                    if (!!ceiling && oldMap.size < ceiling) {
                        oldMap.set(key, item);
                    }
                    else if (!ceiling) {
                        oldMap.set(key, item);
                    }
                }
            });
            setSelectValue(oldMap);
            const list = [...oldMap.values()];
            if (singleType) {
                const signleItem = list.pop();
                if (signleItem) {
                    changeHandle && changeHandle([signleItem], [signleItem]);
                }
                else {
                    changeHandle && changeHandle([], []);
                }
            }
            else {
                changeHandle && changeHandle(list, list);
            }
        }
        else {
            changeHandle && changeHandle([], []);
        }
        setSearchValue('');
    };
    const handleSearch = (str) => {
        setSearchValue(str);
    };
    const doSearchContact = (query) => {
        const fetchId = fetchLock.setFetchId();
        contactApi.doSearchAllContactNew({
            query,
            isIM,
            showDisable: false,
            useEdmData: useEdm && process.env.BUILD_ISEDM,
            noRelateEnterprise,
            _account,
        }, async (result) => {
            var _a;
            if (fetchId !== fetchLock.getFetchId()) {
                return;
            }
            const { main, edm } = result;
            let myCustomerContacts = [];
            let myClueContacts = [];
            let myCustomerOrgs = [];
            let myClueOrgs = [];
            if (useEdm && edm) {
                const orderEdmData = transCustomerSearchData(edm);
                myCustomerContacts = orderEdmData['myCustomerContact'];
                myCustomerOrgs = orderEdmData['myCustomer'];
            }
            const personalContacts = [];
            const enterpriseContacts = [];
            const otherContacts = [];
            const teams = [];
            const personalGroups = [];
            const allAccountsOrgIdMap = Object.keys(main).reduce((total, subEmail) => {
                const { personalOrgList } = main[subEmail];
                if (!personalOrgList || !personalOrgList.length) {
                    return total;
                }
                total[subEmail] = personalOrgList.map(item => {
                    return item.id;
                });
                return total;
            }, {});
            try {
                const promiseRequestList = Object.keys(allAccountsOrgIdMap).map(subAccount => {
                    return contactApi.queryPersonalMemberCount(allAccountsOrgIdMap[subAccount], subAccount);
                });
                const allPersonalGroupList = await Promise.all(promiseRequestList);
                Object.keys(allAccountsOrgIdMap).forEach((subAccount, index) => {
                    const personalGroupMap = allPersonalGroupList[index];
                    main[subAccount].personalOrgList = main[subAccount].personalOrgList
                        .filter(orgItem => {
                        const { id } = orgItem;
                        return lodashGet(personalGroupMap, `[${id}]`, 0);
                    })
                        .map(orgItem => {
                        const { id } = orgItem;
                        orgItem.orgName = `${orgItem.orgName}(联系组)`;
                        orgItem.memberNum = lodashGet(personalGroupMap, `[${id}]`, 0);
                        return orgItem;
                    });
                });
            }
            catch (ex) { }
            Object.keys(main).forEach(account => {
                const data = main[account] || {};
                const { contactList, teamList, personalOrgList } = data;
                if (contactList === null || contactList === void 0 ? void 0 : contactList.length) {
                    data.contactList.forEach(item => {
                        const { type } = item;
                        const transferedItem = transContactSearch2ContactItem(item);
                        if (type === 'enterprise') {
                            enterpriseContacts.push(transferedItem);
                        }
                        else if (type === 'personal') {
                            personalContacts.push(transferedItem);
                        }
                        else {
                            otherContacts.push(transferedItem);
                        }
                    });
                }
                if ((teamList === null || teamList === void 0 ? void 0 : teamList.length) && needTeam) {
                    teamList.forEach(item => {
                        teams.push(transOrgSearch2OrgItem(item));
                    });
                }
                if (personalOrgList && personalOrgList.length && needPersonalOrg) {
                    personalOrgList.forEach(item => {
                        personalGroups.push(transOrgSearch2OrgItem(item));
                    });
                }
            });
            const email = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
            const allContactSet = new Set();
            const duplicateRemContacts = [...enterpriseContacts, ...myCustomerContacts, ...myClueContacts, ...personalContacts, ...otherContacts].reduce((total, cur) => {
                const { email: emailAddr } = cur;
                const isSelected = selectValue.has(getContactItemKey(cur));
                const isSelf = includeSelf && cur.email === email;
                if (!allContactSet.has(emailAddr) && (!isSelected || isSelf)) {
                    allContactSet.add(emailAddr);
                    return [...total, cur];
                }
                return [...total];
            }, []);
            allContactSet.clear();
            const searchedList = [...duplicateRemContacts, ...personalGroups, ...teams, ...myCustomerOrgs, ...myClueOrgs];
            setSearchList(searchedList);
        });
    };
    const debounceSearch = useCallback(debounce(val => {
        doSearchContact(val);
    }, 700, {
        leading: true,
    }), []);
    const handleBlur = () => {
        setTimeout(() => {
            var _a;
            setSearchValue('');
            setMaxTagCount('responsive');
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 300);
    };
    const handleFocus = () => {
        setMaxTagCount(undefined);
        setTimeout(() => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 100);
    };
    const handleSuffixClick = () => {
        showSuffix && onClickSuffix && onClickSuffix();
    };
    useContactItemEffect(defaultSelectList, () => {
        const itemMap = new Map();
        defaultSelectList.forEach(item => {
            const key = getContactItemKey(item);
            itemMap.set(key, item);
        });
        setSelectValue(itemMap);
    });
    useEffect(() => {
        if (searchValue) {
            debounceSearch(searchValue);
        }
    }, [searchValue]);
    const selectValueList = useMemo(() => {
        const list = [];
        selectValue.forEach(item => {
            var _a;
            const key = getContactItemKey(item);
            list.push({
                key,
                value: (_a = item.email) === null || _a === void 0 ? void 0 : _a.trim(),
                isLeaf: true,
                label: React.createElement(OptionItem, { searchValue: searchValue, item: item, isOrg: false }),
            });
        });
        if (singleType)
            return list.slice(list.length - 1);
        return list;
    }, [selectValue]);
    const options = useMemo(() => {
        var _a;
        let list = [];
        if (searchValue) {
            const trimSearchValue = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim();
            if (source === 'mailClassify') {
                if (recent100) {
                    const { contacts } = recent100;
                    let curContacts = [...contacts];
                    (curContacts || []).splice(0, 100).forEach(item => {
                        const id = item.contactItem.contactItemVal;
                        if (id && id.includes(trimSearchValue)) {
                            const optItem = {
                                id,
                                email: id,
                                name: (item === null || item === void 0 ? void 0 : item.originName) || id,
                                type: item.contactItem.type,
                            };
                            list.push({
                                key: id,
                                value: id,
                                isLeaf: false,
                                noData: true,
                                label: React.createElement(OptionItem, { key: id, item: optItem, isOrg: false }),
                            });
                        }
                    });
                }
            }
            searchList === null || searchList === void 0 ? void 0 : searchList.forEach(item => {
                if (item) {
                    if (isOrg(item)) {
                        list.push({
                            search: searchValue,
                            key: item.id,
                            value: item.id,
                            isLeaf: false,
                            label: React.createElement(OptionItem, { key: item.id, searchValue: searchValue, item: item, isOrg: true }),
                        });
                    }
                    else {
                        const key = getContactItemKey(item);
                        list.push({
                            search: searchValue,
                            key,
                            value: key === null || key === void 0 ? void 0 : key.trim(),
                            isLeaf: true,
                            label: React.createElement(OptionItem, { searchValue: searchValue, item: item, isOrg: false }),
                        });
                    }
                }
            });
            if (showNoData) {
                const isExist = selectValueList.some(item => item.value === trimSearchValue);
                if (!isExist && unSelect && trimSearchValue) {
                    list.unshift({
                        key: `noData${trimSearchValue}`,
                        value: trimSearchValue,
                        isLeaf: false,
                        noData: true,
                        label: React.createElement(OptionNoDataItem, { searchValue: trimSearchValue, noData: true }),
                    });
                }
                else if (!isExist && !list.length && trimSearchValue) {
                    list.push({
                        key: `noData${trimSearchValue}`,
                        value: trimSearchValue,
                        isLeaf: false,
                        noData: true,
                        label: React.createElement(OptionNoDataItem, { searchValue: trimSearchValue, noData: true }),
                    });
                }
            }
        }
        else {
            if (source === 'mailClassify') {
                if (recent100) {
                    const { senders, receivers, receiverAndCcs, ccs } = recent100;
                    const { type } = field || {};
                    let curContacts = [];
                    if (!type || type === 'from')
                        curContacts = senders;
                    if (type === 'to')
                        curContacts = receivers;
                    if (type === 'cc')
                        curContacts = receivers;
                    if (type === 'recipients')
                        curContacts = receiverAndCcs;
                    list = (_a = (curContacts || [])) === null || _a === void 0 ? void 0 : _a.map(item => {
                        const id = item.contactItem.contactItemVal;
                        const optItem = {
                            id,
                            email: id,
                            name: (item === null || item === void 0 ? void 0 : item.originName) || id,
                            type: item.contactItem.type,
                        };
                        return {
                            key: id,
                            value: id,
                            isLeaf: false,
                            noData: true,
                            label: React.createElement(OptionItem, { key: id, item: optItem, isOrg: false }),
                        };
                    });
                }
            }
        }
        return list;
    }, [searchList, searchValue, showNoData, selectValueList, recent100 === null || recent100 === void 0 ? void 0 : recent100.updateTime, field]);
    useEffect(() => {
        if (inWindow()) {
            const sel = document.querySelector(`.${styles.selectWrapper} .ant-select-selector`);
            if (sel) {
                sel.scrollTop = sel.scrollHeight;
            }
        }
        return () => { };
    }, [scrollFlag]);
    const isExist = selectValueList.some(item => item.value === searchValue.trim());
    const dropDownHideFirstChild = unSelect && options.length > 1 && !isExist;
    const undropDownHideFirstChild = unSelect && options.length <= 1 && isExist;
    const handleKeydown = (e) => {
        const keycode = e.nativeEvent.key;
        if ((keycode === 'Enter' || keycode === ';' || keycode === ',') && searchValue) {
            const tokenSeparators = [',', ';'];
            const currentInput = searchValue.trim();
            if (tokenSeparators.some(sep => currentInput.includes(sep)) || keycode === ';' || keycode === ',') {
                e.preventDefault();
                handleMultiEmailInput(currentInput);
                return;
            }
            if (keycode === 'Enter' && repeatToast && (selectValueList === null || selectValueList === void 0 ? void 0 : selectValueList.length) && (dropDownHideFirstChild || undropDownHideFirstChild) && isExist) {
                e.preventDefault();
                SiriusMessage.warn({ content: getIn18Text('YIYOUZHONGFUNEI') });
                setSearchValue('');
                return;
            }
        }
    };
    const handleMultiEmailInput = (inputValue) => {
        const tokenSeparators = [',', ';'];
        const emails = inputValue
            .split(new RegExp(`[${tokenSeparators.join('')}]`))
            .map(email => email.trim())
            .filter(email => email);
        if (emails.length === 0)
            return;
        const invalidEmails = emails.filter(email => !verifyEmail(email));
        if (invalidEmails.length > 0) {
            SiriusMessage.error({
                content: getIn18Text('YOUXIANGGESHIBUZHENGQUE').replace('{emails}', invalidEmails.join(', ')),
            });
            return;
        }
        const newContacts = emails.map(email => creatExternalContentItem(email));
        const currentList = Array.from(selectValue.values());
        const mergedContacts = [...currentList, ...newContacts];
        const uniqueContacts = mergedContacts.filter((item, index, arr) => {
            return (index ===
                arr.findIndex(t => {
                    if (item.id && t.id) {
                        return item.id === t.id;
                    }
                    if (item.email && t.email) {
                        return item.email === t.email;
                    }
                    return item === t;
                }));
        });
        const newSelectValue = new Map();
        uniqueContacts.forEach(contact => {
            const key = getContactItemKey(contact, false);
            newSelectValue.set(key, contact);
        });
        setSelectValue(newSelectValue);
        setSearchValue('');
        changeHandle && changeHandle(newContacts, uniqueContacts);
    };
    const handleClear = useCallback(() => {
        setSelectValue(new Map());
        changeHandle && changeHandle([], []);
    }, [setSelectValue, changeHandle]);
    const visibleClearBtn = useMemo(() => {
        return Boolean(showClear && !maxTagCount && (searchValue || selectValue.size));
    }, [searchValue, maxTagCount, showClear, selectValue]);
    const suffixDisable = ceiling && selectValueList.length >= ceiling;
    return (React.createElement("div", { className: classnames(styles.contactSelectWrap, 'sirius-contact-wrap'), ref: refRorInput, "data-test-id": "contact_select_input" },
        React.createElement(InputContextMenu, { inputOutRef: refRorInput, changeVal: handleSearch },
            React.createElement(Select, Object.assign({}, props, { ref: ref, mode: "multiple", dropdownClassName: classnames(styles.dropDownWrapper, dropdownClassName, {
                    [styles.dropDownHideFirstChild]: dropDownHideFirstChild,
                }), className: classnames(className, styles.contactSelectWrap, {
                    [styles.suffixPadding]: showSuffix && useSuffixIcon,
                    [styles.suffixPaddingTxt]: !useSuffixIcon && showSuffix,
                    [styles.clearPadding]: showClear && !showSuffix,
                    [styles.clearSuffixIconPadding]: showClear && showSuffix && useSuffixIcon,
                    [styles.clearSuffixTxtPadding]: showClear && showSuffix && !useSuffixIcon,
                    [styles.contactSelectScroll]: multiRow,
                }), onSearch: handleSearch, tagRender: renderTagFunc(firstPositionNotDelEmail, { hideAvatar, characterLimit }), notFoundContent: null, value: selectValueList, searchValue: searchValue }, (!multiRow && { maxTagCount }), { maxTagPlaceholder: React.createElement("span", null, `${getIn18Text('GONG')}${selectValueList.length}${getIn18Text('REN')}`), menuItemSelectedIcon: null, onChange: handleChange, labelInValue: true, optionFilterProp: "label", filterOption: (_, option) => !selectValue.has(option.key), onBlur: handleBlur, onFocus: handleFocus, options: options, dropdownRender: menu => {
                    if (source === 'mailClassify') {
                        if (!searchValue) {
                            return (React.createElement("div", { className: styles.dropdownMailClassify },
                                React.createElement("p", { className: styles.recommand }, getIn18Text('TUIJIANLIANXIREN')),
                                menu,
                                React.createElement("p", { className: styles.selectFromContact, onClick: () => (suffixDisable ? {} : handleSuffixClick()) },
                                    React.createElement("img", { src: contactSelect }),
                                    getIn18Text('CONGLIANXIRXZ'))));
                        }
                    }
                    return React.createElement(React.Fragment, null, menu);
                }, onKeyDown: handleKeydown }))),
        visibleClearBtn && (React.createElement("div", { "data-test-id": "contact_select_input_btn_clear", className: styles.contactSelectClearIcon, style: { right: !useSuffixIcon ? 92 : 36 }, onClick: handleClear })),
        showSuffix && (React.createElement("div", { "data-test-id": "contact_select_input_btn_openModal", className: classnames({
                [styles.contactSelectSuffixIcon]: useSuffixIcon,
                [styles.contactSelectSuffixTxt]: !useSuffixIcon,
                [styles.contactSelectSuffixIconDisable]: useSuffixIcon && suffixDisable,
                [styles.contactSelectSuffixTxtDisable]: !useSuffixIcon && suffixDisable,
            }), onClick: () => (suffixDisable ? {} : handleSuffixClick()) }, !useSuffixIcon ? getIn18Text('TIANJIAGERENCHENGYUAN') : ''))));
};
export default SelectInput;
